import axios from 'axios';
import { refreshToken } from './auth';
import { getBaseUrl } from './helpers';

// API Endpoints
const GET_BUILDING_LIST_ENDPOINT = `/building/api/buildings/?partial=1&is_pi=1`;

export * from './auth';
export * from './savings';
export * from './incidents';
export * from './diagnostics';

export const getBuildingList = async (env, search = '') => {
  const BASE_URL = getBaseUrl(env);
  const API_ENDPOINT = search ? `/building/api/buildings/?search=${search}` : GET_BUILDING_LIST_ENDPOINT;
  let authToken = JSON.parse(sessionStorage.getItem('token')) || '';

  if (!authToken) {
    const refreshed = await refreshToken(env);
    if (!refreshed) {
      return null
    }
    authToken = refreshed.token;
  }

  try {
    const response = await axios.get(`${BASE_URL}${API_ENDPOINT}`, {
        headers: {
          Authorization: `JWT ${authToken}`,
          'Content-Type': 'application/json',
        },
      });

      return response.data
  } catch (error) {
    if (error.response?.status === 401) {
      const refreshed = await refreshToken(env);

      if (!refreshed) {
        return null;
      }

      return getBuildingList(env, search);
    }
    return Promise.reject(error.response?.data?.errors?.[0]?.message);
  }
  
};
